import { Component, computed, EventEmitter, Input, OnInit, Output, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { ApplicantForm } from '../../forms/applicant.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../openapi';
import {
  ApplicantCorrespondenceFormComponent
} from '../applicant-correspondence-form/applicant-correspondence-form.component';
import { selectEntityTypes } from '../../../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-institution-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective,
    ApplicantCorrespondenceFormComponent
  ],
  templateUrl: './institution-form.component.html'
})
export class InstitutionFormComponent implements OnInit {

  @Input()
  public entityTypeCode: string | undefined;

  private entityTypeId: Signal<string> = computed(() => {
    const types = this.store$.selectSignal(selectEntityTypes);
    return types().filter(v => v.code === this.entityTypeCode).at(0)?.id || '';
  });

  @Input()
  public form: ApplicantForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  @Input()
  public edit = false;

  constructor(private store$: Store) {
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.entityTypeId() });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.entityTypeId() });
  }

  public ngOnInit(): void {
    this.form?.applicantType.setValue(this.entityTypeId());

    this.form?.name.enable();
    this.form?.nip.enable();

    this.form?.firstName.disable();
    this.form?.lastName.disable();

    this.form?.pesel?.disable();

    this.form?.country.disable();
    this.form?.voivodeship.disable();
    this.form?.county.disable();
    this.form?.municipality.disable();
  }
}
